export const checkIfSubMenuHasPermissionTrue = item => {
  if (item.subMenu && item.subMenu.length > 0) {
    const permission = item.subMenu.some(subItem => subItem.acesso === true);
    return !permission;
  }

  return !item.acesso;
};
export const menuAdmin = data => {
  const menu = {
    first: data[0]?.menu
      ?.filter(item => item.nome !== 'Home')
      ?.map(item => {
        const menuItem = {
          label: item.nome,
          link: item.nome === 'Home' ? '/home' : item.url,
          disabled: checkIfSubMenuHasPermissionTrue(item),
          isExternal: true,
        };

        if (item.subMenu && item.subMenu.length > 0) {
          menuItem.children = item.subMenu.map(subItem => ({
            label: subItem.nome,
            link: subItem.url,
            disabled: !subItem.acesso,
            isExternal: true,
          }));
        }

        return menuItem;
      }),
  };
  return menu;
};
